import { Environments } from '../store/CheckoutContext';

export const BASE_URL = {
  IFRAME_URL: process.env.REACT_APP_IFRAME_URL,
  PAYMENT_SERVER_URL: process.env.REACT_APP_PAYMENT_URL,
  REACT_APP_DEMO_IFRAME_URL: process.env.REACT_APP_DEMO_IFRAME_URL,
  SPREEDLY_URL: process.env.REACT_APP_SPREEDLY_URL,
  API_CLIENT_URL: process.env.REACT_APP_API_CLIENT_URL,
  API_IDENTITY_URL: process.env.REACT_APP_API_CLIENT_URL,
};

export const getBaseUrl = (environment: Environments) => {
  switch (environment) {
    case 'development':
    case 'local':
      return {
        IFRAME_URL: `http://localhost:3002/checkout/?id=${
          window?.location.href.includes('/checkout-iframe-sensejs') ? 'senseOnly' : 'bothWidgets'
        }`,
        PAYMENT_SERVER_URL: 'http://localhost:3001/',
      };
    case 'staging':
      return {
        IFRAME_URL: `https://fc-payment-page-simulator-staging.flexfactor.io/checkout/?id=${
          window?.location.href.includes('/checkout-iframe-sensejs') ? 'senseOnly' : 'bothWidgets'
        }`,
        PAYMENT_SERVER_URL: 'https://fc-payment-page-simulator-server.flexfactor.io/',
      };
    case 'sandbox':
    case 'production':
      return {
        IFRAME_URL: `https://payment-page-simulator-sandbox.flexfactor.io/checkout/?id=${
          window?.location.href.includes('/checkout-iframe-sensejs') ? 'senseOnly' : 'bothWidgets'
        }`,
        PAYMENT_SERVER_URL: 'https://sandbox-payment-page-sim-server.flexfactor.io/',
      };
  }
};

export const getBaseAPIUrl = (environment: Environments, name: string): string | undefined => {
  let BASE_URL = 'https://api-staging.flex-charge.com';
  switch (environment) {
    case 'sandbox':
      BASE_URL = 'https://api-sandbox.flex-charge.com';
      break;
    case 'production':
      BASE_URL = 'https://api.flex-charge.com';
      break;
  }

  switch (name) {
    case 'tokenize':
      return process.env.REACT_APP_ENVIRONMENT === Environments.local
        ? 'http://localhost:5022/PaymentInstruments'
        : `${BASE_URL}/v1`;
    case 'auth':
      return process.env.REACT_APP_ENVIRONMENT === Environments.local
        ? 'http://localhost:5279/oauth2/token'
        : // `${BASE_URL}/v1/oauth2/token`
          `${BASE_URL}/v1/oauth2/token`;
    case 'evaluate':
      return process.env.REACT_APP_ENVIRONMENT === Environments.local
        ? 'http://localhost:5013/evaluate'
        : `${BASE_URL}/v1/evaluate`;
    case 'sale':
      return process.env.REACT_APP_ENVIRONMENT === Environments.local
        ? 'http://localhost:5013/sale'
        : `${BASE_URL}/v1/sale`;
    case 'eligibility':
      return process.env.REACT_APP_ENVIRONMENT === Environments.local ? 'http://localhost:5013' : `${BASE_URL}/v1`;
    case 'configuration':
      return process.env.REACT_APP_ENVIRONMENT === Environments.local
        ? 'http://localhost:5301/configuration'
        : `${BASE_URL}/v1/configuration`;
  }

  // switch (name) {
  //   case 'auth':
  //     return `${BASE_URL}/v1/oauth2/token`;
  //   case 'evaluate':
  //     return `${BASE_URL}/v1/evaluate`;
  //   // return `${BASE_URL}/evaluate`;
  //   case 'eligibility':
  //     return `${BASE_URL}/v1/`;
  // }
};

export const getSenseJsServerUrl = (environment: Environments) => {
  switch (environment) {
    case 'development':
      return 'http://localhost:3000/';
    case 'local':
      return 'http://localhost:3000/';
    case 'production':
      return 'https://sensejs-server.flex-charge.com/';
    case 'sandbox':
      return 'https://sandbox-sensejs-server.flex-charge.com/';
    case 'staging':
      return 'https://sensejs-staging.flex-charge.com/';
  }
};
